import React from 'react'
import cookies from 'js-cookie'
import queryString from 'query-string'
import { Button, IconSocialGoogleActive } from '@mc/design-system'
import { isInAppBrowser } from '@mc/devices'

interface GoogleButtonProps {
  children?: React.ReactNode | React.ReactNode[]
  userAgent?: string
  onClick?: () => void
}

const GoogleButton = ({
  children,
  userAgent = '',
  onClick,
}: GoogleButtonProps) => {
  // see isInAppBrowser to understand why
  if (isInAppBrowser(userAgent)) return null

  const linkToGoogleAuth = () => {
    onClick?.()
    const queryParams = queryString.parse(window.location.search)
    if (queryParams && queryParams.next_page) {
      cookies.set('last_mc_url', queryParams.next_page as string)
    }
    window.location.href = '/auth/google_oauth2/'
  }

  return (
    <Button kind='google' onClick={linkToGoogleAuth} fullWidth>
      <IconSocialGoogleActive size='lg' className='mc-mr-3' />
      {children}
    </Button>
  )
}

export default GoogleButton
